import api from './api';

const getSubscribeData = (params) => {
  return api.get('customer/v1/subscribe?email=' + params);
};

export default { getSubscribeData };
